const MuiCardContent = {
  styleOverrides: {
    root: {
      '&:last-child': {
        paddingBottom: '0 !important',
      },
    },
  },
};

export default MuiCardContent;
